import { EasySearchHitDto } from '@dhl/mdp-api'
import { Alert, Body1, Grid } from '@dhl-ui/components'
import { ErrorIcon, WarningYellowIcon } from '~/common/components/icons'

type Props = {
  hit: EasySearchHitDto
}

export const PppErrors = ({ hit: { errors } }: Props) =>
  errors ? (
    <Alert severity="error">
      <Grid container direction="column" sx={{ mb: 1 }}>
        {errors.map(({ errorMessage, errorLevel }, index) => (
          <Grid key={index} sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
            {errorLevel === 'Warning' ? <WarningYellowIcon /> : <ErrorIcon />}
            <Body1 variant="primary">{errorMessage}</Body1>
          </Grid>
        ))}
      </Grid>
    </Alert>
  ) : null
